import { useEffect, useState } from 'react';
import { useNavigate, NavLink, Outlet } from 'react-router-dom';

export default function AdminLayout() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');

  useEffect(() => {
    const p = sessionStorage.getItem('admin_phone');
    if (!p) {
      navigate('/admin/login', { replace: true });
    } else {
      setPhone(p);
    }
  }, [navigate]);

  const signOut = () => {
    sessionStorage.removeItem('admin_phone');
    try { window.Clerk?.signOut(); } catch {}
    navigate('/admin/login', { replace: true });
  };

  if (!phone) return null;

  return (
    <div style={styles.shell}>
      <header style={styles.header}>
        <div style={styles.logo}>candid. <span style={styles.adminTag}>admin</span></div>
        <div style={styles.headerRight}>
          <span style={styles.phone}>{phone}</span>
          <button style={styles.signOut} onClick={signOut}>Sign out</button>
        </div>
      </header>

      <nav style={styles.nav}>
        <Tab to="/admin/selfies" label="Selfies" />
        <Tab to="/admin/photos" label="Photos" />
        <Tab to="/admin/reports" label="Reports" />
        <Tab to="/admin/users" label="Users" />
        <Tab to="/admin/metrics" label="Metrics" />
      </nav>

      <main style={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}

function Tab({ to, label }) {
  return (
    <NavLink
      to={to}
      style={({ isActive }) => ({
        padding: '12px 20px',
        color: isActive ? '#a78bfa' : '#888',
        textDecoration: 'none',
        fontSize: 14,
        fontWeight: 600,
        borderBottom: isActive ? '2px solid #a78bfa' : '2px solid transparent',
      })}
    >
      {label}
    </NavLink>
  );
}

const styles = {
  shell: { minHeight: '100vh', background: '#030010', color: '#fff', fontFamily: 'system-ui, -apple-system, sans-serif' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 32px', borderBottom: '1px solid rgba(255,255,255,0.08)' },
  logo: { fontSize: 22, fontWeight: 900, letterSpacing: -1, background: 'linear-gradient(90deg, #a78bfa, #f472b6, #fb923c)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' },
  adminTag: { fontSize: 12, fontWeight: 500, color: '#888', WebkitTextFillColor: '#888', background: 'none', letterSpacing: 0, marginLeft: 6 },
  headerRight: { display: 'flex', alignItems: 'center', gap: 16 },
  phone: { fontSize: 13, color: '#888' },
  signOut: { background: 'none', border: '1px solid rgba(255,255,255,0.15)', color: '#888', padding: '6px 12px', borderRadius: 999, fontSize: 12, cursor: 'pointer' },
  nav: { display: 'flex', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingLeft: 16 },
  main: { padding: 32 },
};
